import { SavedIcon, TrashIcon } from "@dataone/icons";
import {
  DeleteModal,
  ISearchHistory,
  QUERIES,
  deleteSearchHistory,
  openNotification,
  switchMarkedSearchHistory,
} from "@dataone/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "antd";
import { useState } from "react";
import { styled } from "styled-components";

interface PopoverContentProps {
  search: ISearchHistory;
  action: string;
}

export const PopoverContent = ({ search, action }: PopoverContentProps) => {
  const [activeButton, setActiveButton] = useState("0");
  const [searchToDelete, setSearchToDelete] = useState<ISearchHistory | null>(
    null
  );

  const queryClient = useQueryClient();

  const { mutate: deleteSearch } = useMutation(deleteSearchHistory);
  const { mutate: switchMarkedSearch } = useMutation(switchMarkedSearchHistory);

  const handleCancelDelete = () => {
    setSearchToDelete(null);
  };

  const handleConfirmDelete = () => {
    searchToDelete &&
      deleteSearch(searchToDelete.id, {
        onSuccess: ({ message }) => {
          openNotification(message);
          onActionSuccess();
        },
      });
  };

  const handleSwitchMarked = () => {
    switchMarkedSearch(search.id, {
      onSuccess: ({ message }) => {
        openNotification(message);
        onActionSuccess();
      },
    });
  };

  const onActionSuccess = () => {
    setSearchToDelete(null);
    queryClient.invalidateQueries([QUERIES.SEARCH_MARKED_HISTORY]);
    queryClient.invalidateQueries([QUERIES.SEARCH_HISTORY]);
  };

  return (
    <StyledPopover>
      <Button
        className={`action-button ${activeButton === "1" ? "first-btn-active" : ""
          }`}
        type="link"
        icon={
          <StyledIcon activeButton={activeButton === "1" ? true : false}>
            <SavedIcon />
          </StyledIcon>
        }
        onClick={handleSwitchMarked}
        onMouseEnter={() => setActiveButton("1")}
        onMouseLeave={() => setActiveButton("0")}
      >
        <span className="label">{action}</span>
      </Button>
      <Button
        className={`action-button ${activeButton === "2" ? "active-trash" : ""
          }`}
        type="link"
        icon={
          <StyledTrashIcon>
            <TrashIcon />
          </StyledTrashIcon>
        }
        onClick={() => setSearchToDelete(search)}
        onMouseEnter={() => setActiveButton("2")}
        onMouseLeave={() => setActiveButton("0")}
      >
        <span className="label">Remove</span>
      </Button>
      <DeleteModal
        header="Are you sure you want
        to delete this search ?"
        containerId="#smartsearch-modal"
        typeToDelete="search"
        isModalOpen={!!searchToDelete}
        selectedTitle={search.message}
        handleCancel={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
      />
    </StyledPopover>
  );
};

const StyledPopover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .action-button {
    display: flex;
    align-items: center;
    color: black;
    width: 100%;
    height: 40px;
    text-align: left;
    padding-block: 20px;
  }
  .action-button .label {
    margin-left: 8px;
    font-size: 14px;
  }
  .action-button.active {
    color: #fff !important;
    background-color: #4974f6 !important;
    text-decoration: none !important;
    opacity: 0.8;
    border-radius: 0px;
  }
  .action-button.active-trash {
    color: rgba(255, 0, 0, 1) !important;
    background-color: rgba(255, 175, 175, 1) !important;
    text-decoration: none !important;
    opacity: 0.8;
    border-radius: 0 0 8px 8px;
  }
  .first-btn-active {
    color: #fff !important;
    background-color: #4974f6 !important;
    text-decoration: none !important;
    opacity: 0.8;
    border-radius: 8px 8px 0 0;
  }
`;

const StyledTrashIcon = styled.div`
  display: flex;
  justify-content: center;
  font-size: 20px;
  color: #ff0000;
`;

const StyledIcon = styled.div<{ activeButton: boolean }>`
  display: flex;
  color: ${({ activeButton }) => (activeButton ? "#fff" : "#4974f6")};
  font-size: 18px;
`;
